import { CREATE_STARTUP_MUTATION } from "../mutations/createStartupMutation";
import { PUBLISH_STARTUP_MUTATION } from "../mutations/publishStartupMutation";
import { GENERATE_LAYOUT_MUTATION } from "../mutations/generateLayoutMutation";
import { PUBLISH_PAGE_LAYOUT_MUTATION } from "../mutations/publishPageLayoutMutation"; // Import publish page layout mutation
import { PUBLISH_MENU_LAYOUT_MUTATION } from "../mutations/publishMenuLayoutMutation";
import { client } from "../apolloClient"; // Import shared Apollo Client instance

// API call to create a new startup folder in S3
export const createStartupApi = async (startupName) => {
  console.log(
    `PMM - SF - startupApi.js - createStartupApi - startupName is: ${JSON.stringify(
      startupName
    )}`
  );

  const inputPayload = {
    startupName,
    operationType: "CREATE_STARTUP",
    files: [
      {
        filename: "index.js",
        content: "console.log('Hello World!');", // Example file content
      },
    ],
  };

  try {
    const response = await client.mutate({
      mutation: CREATE_STARTUP_MUTATION,
      variables: { input: inputPayload },
    });

    return response.data.createStartup;
  } catch (error) {
    console.error(`Error creating startup: ${error.message}`);
    throw error;
  }
};

// API call to publish a startup
export const publishStartupApi = async (startupName) => {
  console.log(
    `PMM - SF - startupApi.js - publishStartupApi - startupName is: ${JSON.stringify(
      startupName
    )}`
  );

  const inputPayload = {
    startupName,
    operationType: "PUBLISH_STARTUP",
  };

  try {
    const response = await client.mutate({
      mutation: PUBLISH_STARTUP_MUTATION,
      variables: { input: inputPayload },
    });

    return response.data.publishStartup;
  } catch (error) {
    console.error(`Error publishing startup: ${error.message}`);
    throw error;
  }
};

// API call to generate layout files
export const generateLayoutApi = async (startupName, pageName) => {
  console.log(
    `PMM - SF - generateLayoutApi - startupName: ${startupName}, pageName: ${pageName}`
  );

  const inputPayload = {
    startupName,
    pageName,
  };

  try {
    const response = await client.mutate({
      mutation: GENERATE_LAYOUT_MUTATION,
      variables: { input: inputPayload },
    });

    return response.data.generateLayout;
  } catch (error) {
    console.error(`Error generating layout: ${error.message}`);
    throw error;
  }
};

// API call to publish the current page layout
export const publishPageLayoutApi = async (payload) => {
  console.log(
    `PMM - SF - publishPageLayoutApi - startupName: ${payload?.startupName}, pageName: ${payload?.pageName}`
  );

  // const inputPayload = {
  //   operationType: payload.operationType,
  //   startupName: payload.startupName,
  //   pageName: payload.pageName,
  //   pageLayoutConfigString: payload.pageLayoutConfigString,
  //   theme: payload.theme,
  //   menuItems: payload.menuItems,
  // };

  console.log(
    `PMM - SF - publishPageLayoutApi - payload: ${JSON.stringify(payload)}`
  );

  try {
    const response = await client.mutate({
      mutation: PUBLISH_PAGE_LAYOUT_MUTATION,
      variables: { input: payload },
    });
    console.log(`- response is: ${JSON.stringify(response)}`);

    console.log(
      `PMM - SF - startupApi - response is: ${JSON.stringify(response)}`
    );

    return response.data;
  } catch (error) {
    console.log(
      `PMM - SF - startupApi - publish page layout - catch hit - error is: ${JSON.stringify(
        error
      )}`
    );
    console.error(`Error publishing page layout: ${error}`);
    throw error;
  }
};

// API call to publish the current menu layout
export const publishMenuLayoutApi = async (payload) => {
  console.log(
    `PMM - SF - publishMenuLayoutApi - payload is: ${JSON.stringify(payload)}`
  );

  const inputPayload = {
    operationType: "PUBLISH_MENU_LAYOUT_CONFIG",
    startupName: payload.startupName,
    menuName: payload.menuName,
    menuItems: payload?.menuItems,
    theme: payload?.themeConfig,
  };

  console.log(`PMM - SF - inputPayload is: ${JSON.stringify(inputPayload)}`);

  try {
    const response = await client.mutate({
      mutation: PUBLISH_MENU_LAYOUT_MUTATION,
      variables: { input: inputPayload },
    });
    console.log(
      `PMM - SF - startupApi - success - response is: ${JSON.stringify(
        response
      )}`
    );

    console.log(
      `PMM - SF - startupApi - response is: ${JSON.stringify(response)}`
    );

    return response.data;
  } catch (error) {
    console.error(`Error publishing page layout: ${error}`);
    throw error;
  }
};
